import {css, StyleSheet} from 'aphrodite';
import classnames from 'classnames';
import React from 'react';

import isArchivable from 'archive/isArchivable';
import {ActionOrigin, ProcessPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExecuteTaskGroupsButton, {
  ProcessForExecuteTaskGroupsButton,
} from 'processes/dashboard/ExecuteTaskGroupsButton';
import {isDirectExecutionTaskWithNoOutputSchema} from 'processes/dashboard/ExecuteTasksButton';
import {isProcessPlatformFeatureEnabledAndHasCapability} from 'processes/processes-platform/FeatureOptions';

import {ArchiveRecordGraphQL} from '../../../../graphql-fragments/app-core/platform/archivable/__generated/ArchiveRecordGraphQL';
import {ProcessOutputGraphQL} from '../../../../graphql-fragments/processes/__generated/ProcessOutputGraphQL';
import {ProcessTaskGraphQL} from '../../../../graphql-fragments/processes/__generated/ProcessTaskGraphQL';
import ArchiveProcessButton from './ArchiveProcessButton';

export interface ProcessWithArchiveButtonInfo {
  __typename: 'ProcessNode';
  id: string;
  name: string;
  archiveRecord: ArchiveRecordGraphQL | null;
}

export type ProcessForToolbar = ProcessForExecuteTaskGroupsButton & ProcessWithArchiveButtonInfo;

interface ProcessActionToolbarProps {
  process: ProcessForToolbar;
  forceRefetch: () => Promise<unknown>;
  onTasksOrOutputsChange: (tasks?: Array<ProcessTaskGraphQL>, outputs?: Array<ProcessOutputGraphQL>) => void;
}

export default function ProcessActionToolbar(props: ProcessActionToolbarProps): JSX.Element | null {
  const showExecuteButton =
    isProcessPlatformFeatureEnabledAndHasCapability(
      ProcessPlatformFeatureType.IS_DIRECTLY_EXECUTABLE,
      props.process.processTaskSchema.executionType,
      props.process.processTaskSchema.clientOrigin,
      props.process.processTaskSchema.name
    ) && !isDirectExecutionTaskWithNoOutputSchema(props.process.processTaskSchema);

  return (
    <div className={css(styles.toolbarWrapper)}>
      {isArchivable(props.process) && (
        <ArchiveProcessButton process={props.process} forceRefetch={props.forceRefetch} />
      )}
      {showExecuteButton && (
        <div className={classnames('buttonGroup', css(styles.executionButtonWrapper))}>
          <ExecuteTaskGroupsButton
            processes={[props.process]}
            onTasksOrOutputsChange={(tasks, outputs) => {
              props.onTasksOrOutputsChange(tasks, outputs);
            }}
            actionOrigin={ActionOrigin.WORKFLOWS_TASK_GROUP_PAGE}
          />
        </div>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  toolbarWrapper: {
    display: 'flex',
  },
  executionButtonWrapper: {
    marginLeft: '8px',
  },
});
